import { List, Map } from 'immutable'
import { allowCoBrowse } from '../../constants/features'
import { toJS } from '../../lib/common'
import * as actionTypes from './actionTypes'

export const resetECommerceTransaction = () => (dispatch, getState) => {
  let state = getState()
  state = state.setIn(['state', 'eCommerce', 'transaction'], Map())
  state = state.setIn(['widgets', 'selectedCustomService'], '')
  state = state.setIn(['widgets', 'isShowPaymentModal'], '')

  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: state,
    },
  })
}

export const processChangeLinearLoadingStatus = (status) => (dispatch, getState) =>
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: getState().setIn(['widgets', 'isShowLinearLoading'], status),
    },
  })

export const setStatusHoverModal = (uid, status) => (dispatch, getState) => {
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: getState().setIn(['state', 'projectHover', uid], status),
    },
  })
}

export const processRemoveConfirmation = (uid) => (dispatch, getState) => {
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: getState().setIn(
        ['dialog', 'confirm'],
        getState()
          .getIn(['dialog', 'confirm'], List())
          .filter((v) => v.get('uid') !== uid)
      ),
    },
  })
}

export const processButtonAction =
  (actions, uid, isRepeat, index, options = {}) =>
  (dispatch, getState) => {
    let state = getState()
    let clientY
    if (options && options.clientY) {
      clientY = options.clientY
      window.ftLastClientY = options.clientY
    } else if (window && window.event && window.event.clientY) {
      clientY = window.event.clientY
      window.ftLastClientY = clientY
    }
    if (allowCoBrowse) {
      if (
        state.getIn(['project', 'Settings', 'coBrowse', 'mode'], 'user') !== 'user' &&
        state.getIn(['project', 'Settings', 'coBrowse', 'status'], false)
      ) {
        if (typeof window?.__FT_PROJECT__API__?.onButtonClick === 'function') {
          return window.__FT_PROJECT__API__.onButtonClick({
            uid,
            actions: toJS(actions),
            isRepeat,
            index,
            options: Object.assign(options, { clientY }),
          })
        }
      }
    }
    dispatch({
      type: actionTypes.PROCESS_WB_BUTTON_ACTION,
      payload: {
        uid,
        actions,
        isRepeat,
        index,
        options: Object.assign(options, { clientY }),
      },
    })
  }
